// extracted by mini-css-extract-plugin
export default {"page":"DashboardV2_page__UK0uF","main":"DashboardV2_main__WyGT1"};